import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MissionDto, CreateMission, UpdateMission } from './missioni-dto';


@Injectable({
  providedIn: 'root'
})
export class GestioneMissioniService {

  private url = `${environment.apiUrl}/missions`;

  constructor(private http: HttpClient) { }



  getAllByAdventure(adventureId: string): Observable<MissionDto[]> {
    return this.http.get<MissionDto[]>(`${this.url}/adventure/${adventureId}`);
  }

  create(data: CreateMission): Observable<MissionDto> {
    return this.http.post<MissionDto>(`${this.url}`, data);
  }

  read(id: string): Observable<MissionDto> {
    return this.http.get<MissionDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdateMission): Observable<MissionDto> {
    return this.http.put<MissionDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  getMissionByAdventure(adventureId: string): Observable<MissionDto[]> {
    return this.http.get<MissionDto[]>(`${this.url}/adventure/${adventureId}`);
  }

}
